export const LINKS_KEY = "links";
export const TYPE_KEY = "type";
export const FUNCTIONAL_KEY = "key";
export const NAME_KEY = "name";
export const TITLE_KEY = "title";
export const DESCRIPTION_KEY = "description";
export const PAGES_KEY = "pages";
export const QUESTION_EXPANDED_KEY = "questionExpanded";
export const DESCRIPTION_EXPANDED_KEY = "descriptionExpanded";
export const VISIBLE_KEY = "visible";
export const CHOICE_DESCRIPTION_VISIBLE = "choiceDescriptionVisible";
export const COOKIE_JWT = "jwt";
export const COOKIE_SAP = "sap_token";
export const COOKIE_BANNER_CLOSED = "banner_closed"
export const COOKIE_DOWNTIME_NOTIFICATION_SHOWN = "downtime_notification_shown";
export const DOWNTIME_NOTIFICATION_MESSAGE = "general.notification.downtime";

export const EMPTY = 0;
export const ONE_ELEMENT = 1;

export const ADMIN = "admin";
export const TEMPORARY_USER = "temporary_user";
export const PROJECTLEAD = "projectlead";
export const PROJECTASSISTANT = "projectassistant";
export const PROJECTLEAD_IND = "projectlead_ind";
export const PROJECTASSISTANT_IND = "projectassistant_ind";

export const USER = "user";
export const TEMPLATE_VIEWER = "template_viewer";

export const SURVEY_VIEWER = "survey_viewer";
export const SURVEY_SUBMITTER = "survey_submitter";
export const SURVEY_KEY_EDITOR ="survey_key_editor";
export const RESPONDENT_EDITOR = "survey_respondent_editor";
export const EVALUATION_VIEWER = "evaluation_viewer";
export const INDICATOR_VIEWER = "indicator_viewer";
export const USER_VIEWER = "user_viewer";
export const INDICATOR_EDITOR = "indicator_editor";
export const USER_EDITOR = "user_editor";
export const EVALUATION_IND_VIEWER = "evaluation_ind_viewer";
export const EVALUATION_PRG_VIEWER = "evaluation_prg_viewer";
export const TEMPLATE_CREATOR = "template_creator";
export const LIBRARY_VIEWER = "library_viewer";
export const LIBRARY_EDITOR = "library_editor";
export const PROGRAM_ADMIN = "program_admin";
export const MASTER_DATA_VIEWER = "master_data_viewer";
export const MASTER_DATA_EDITOR = "master_data_editor";
export const ROLE_EDITOR = "role_editor";

export const OTHER_ANSWER_SUFFIX = " | Sonstiges(Text)";
export const OPTION_DELIMITER = " | ";

export const PROPERTY_NAME = "propertyName";
export const PROPERTY_VALUE = "propertyValue";

export const HTTP_STATUS_OK = 200;

export const OTHER_ANSWER = "OtherAnswer"

//links
export const SELF_REL = "self";

export const ROLE_RL = "RL - Aktivitätenmonitoring";
export const ROLE_BL = "BL - Aktivitätenmonitoring";
export const ROLE_AD = "AD - Aktivitätenmonitoring";
export const ROLE_AD_AS = "AD - Außenstellen - Aktivitätenmonitoring";

export const QuestionTypes = {
  text: "text",
  number: "number",
  comment: "comment",
  radio: "radio",
  checkbox: "checkbox",
  dropdown: "dropdown",
  predefinedList: "predefinedList",
  matrixSingleChoice: "matrixSingleChoice",
  matrixMultipleChoice: "matrixMultipleChoice",
  date: "date",
  staticTable: "staticTable",
  dynamicTable: "dynamicTable",
  projectData: "projectData"
};

export const ColumnTypes = {
    text: "Text",
    number: "Number",
    comment: "Comment",
    radio: "Radio",
    checkbox: "Checkbox",
    dropdown: "Dropdown",
    predefinedList: "predefinedList",
    date: "Date"
  };

export const UnitTypes = {
  FUNDING_AREA: "FA",
  PROGRAM: "PG",
  PROGRAM_INSTANCE: "PI",
  PROJECT: "PR"
};

export const ChartColors = ["#0060AF", "#B9326E", "#1E96D2", "#AFC800", "#00A091", "#D7BE28", "#5A2850", "#8296A0"];

export const LOGIN_STORE = "login";
export const FUNDING_AREA_STORE = "fundingArea";
export const LANGUAGE_SELECTOR = "languageSelector";
export const USER_PROFILE = "userProfile";
export const FORGOT_PASSWORD_STORE = "forgotPassword";
export const INDICATOR_MANAGEMENT_STORE = "indicatorManagement";
export const SURVEY_EDITOR = "surveyEditor";
export const SURVEY = "survey";
export const QUESTION_LIBRARY_STORE = "questionLibrary";
export const SURVEY_VIEW_STORE = "surveyView";
export const MASTER_DATA_STORE = "masterData";
export const UNIVERSITY_STORE = "university";
export const COUNTRY_STORE = "country";
export const REGION_STORE = "region";
export const LECTORATE_TYPE_STORE = "lectorateType";
export const ROLE_STORE = "role";
export const USER_MANAGEMENT_STORE = "userManagement";
export const REPORT_ACTIVATION = "reportActivation";

export const GERMAN_LANGUAGE = "de";
export const ENGLISH_LANGUAGE = "en"
export const DEFAULT_LANGUAGE = GERMAN_LANGUAGE;

export const GERMAN_PARAMETER_NAME = "germanName";
export const ENGLISH_PARAMETER_NAME = "englishName"

export const SENT_REPORT_STATUS = "SENT";
